<template>
  <v-row justify="center">
    <v-dialog v-model="Dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Upload A File</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <v-file-input
                  ref="fileupload"
                  label="File input"
                  outlined
                  dense
                  @change="OnUpload"
                  :value="fileData"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeModal"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Success :SuccessCount="successCount" :isShow="isShow" />
    <Error
      :ErrorCount="ErrorCount"
      :isShowError="isShowError"
      :Errors="Errors"
    />
    <Warning
      :ErrorCount="ErrorCount"
      :SuccessCount="successCount"
      :isShowWarning="isShowWarning"
      :Errors="Errors"
      @closeWarningModal="closeWarningModal"
    />
  </v-row>
</template>

<script>
import { API, graphqlOperation, Storage } from "aws-amplify";
import axios from "axios";
import FormData from "form-data";
import Success from "@/views/pages/merchant/paymentrequest/Success.vue";
import Error from "@/views/pages/merchant/paymentrequest/Error.vue";
import Warning from "@/views/pages/merchant/paymentrequest/Warning.vue";

import {
  getDomain,
  getDefaultReceiptUrl
} from "@/services/MerchantSiteInteractionService.js";
export default {
  props: {
    Dialog: Boolean
  },
  components: {
    Success,
    Error,
    Warning
  },
  data() {
    return {
      successCount: 0,
      isShow: false,
      ErrorCount: 0,
      isShowError: false,
      isShowWarning: false,
      Errors: [],
      fileupload: null,
      fileData: []
    };
  },
  methods: {
    closeModal() {
      this.$emit("eClosePaymentUploadFileRequestDialog");
    },
    async OnUpload(file) {
      vm.$logger.debug(file);
      try {
        if (file == null || file.length == 0) {
          vm.$logger.debug("file is null");
          return;
        }
        const name = file.name;
        //  var postResult = await this.GetPresignedPostUrl(name);
        //  this.UploadToS3(postResult, file);
        /*  const paymentfileprocessrequest = {
          objectKey: postResult.data.presignedUrlUpload.key,
          receiptUrl: getDefaultReceiptUrl(),
          domain: getDomain()
        };*/
        vm.$logger.debug("Here 1");
        /*var response = await this.ProcessBatchPayments(
          paymentfileprocessrequest
        );*/
        this.ErrorCount = 1; //response.data.processPaymentFile.failpaymentCount;
        this.successCount = 1;
        // response.data.processPaymentFile.successfulPaymentCount;
        this.Errors = ["one", "two", "three", "four"]; //response.data.processPaymentFile.failedPayments;
        vm.$logger.debug("Here 2");
        if (this.successCount > 0 && this.ErrorCount > 0) {
          this.isShowWarning = true;
        } else if (this.ErrorCount > 0) {
          this.isShowError = true;
        } else if (this.successCount > 0) {
          this.isShow = true;
        }
        vm.$logger.debug("Here 3");

        vm.$logger.debug("Here 4");
        this.closeModal();
        vm.$logger.debug("here 5");
      } catch (error) {
        vm.$logger.error(error);
      }
    },
    CheckFileType(filename) {
      extension = filename.split(".").pop();
      if (extension == "csv") {
        return true;
      } else {
        return false;
      }
    },
    async GetPresignedPostUrl(name) {
      const presignedUrlUpload = `
       query presignedUrlUpload(
         $filename: String!
       ){
         presignedUrlUpload(filename: $filename){
           url
           key
           fields
         }
       }
       `;
      const filename = name;
      const presignedUrlUploadResponse = await API.graphql(
        graphqlOperation(presignedUrlUpload, { filename })
      );
      return presignedUrlUploadResponse;
    },

    MergeList(ErrorList) {
      return [].concat.apply([], ErrorList);
    },
    async ProcessBatchPayments(PaymentFileProcessRequest) {
      const processPaymentFile = `
        query processPaymentFile(
          $paymentRequest: PaymentFileProcessRequest!
        ){
          processPaymentFile(paymentRequest: $paymentRequest){
            failpaymentCount
            successfulPaymentCount
            failedPayments
          }
        }
      `;
      const BatchPaymentResponse = await API.graphql(
        graphqlOperation(processPaymentFile, {
          paymentRequest: PaymentFileProcessRequest
        })
      );
      return BatchPaymentResponse;
    },

    UploadToS3(presignedUrlUploadResponse, file) {
      try {
        const form = new FormData();
        const url = presignedUrlUploadResponse.data.presignedUrlUpload.url;
        const fields = JSON.parse(
          presignedUrlUploadResponse.data.presignedUrlUpload.fields
        );

        Object.entries(fields).forEach(([field, value]) => {
          form.append(field, value);
        });
        form.append("file", file);
        axios({
          method: "post",
          url: url,
          data: form,
          headers: { "Content-Type": "multipart/form-data" }
        });
      } catch (error) {
        vm.$logger.debug(error);
      }
    },
    closeWarningModal() {
      this.$refs.fileupload.reset();
      this.fileData = [];
      this.isShowWarning = false;
    }
  }
};
</script>
